import styled from 'styled-components';

export const FirstRowWrapper = styled.div`
  padding: ${props => (props.isMobile ? '6px 0 0' : '6px 0')};
  border-bottom: 1px solid ${props => props.theme.colors.borderColor};
  button {
      outline: none !important;
      background-color: none !important; 
    }
    .react-datepicker-popper {
      z-index: 999;
    }
    .react-datepicker__current-month {
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${props => props.theme.colors.selectedColor};
      color: #fff;
      font-family: ${props => props.theme.fontSets.narrowRegular};
    }
    .react-datepicker {
      box-shadow: -3px 3px 0 0 rgba(0,0,0,0.2);
      border: 0px;
      border-radius: 0px;
    }
    .react-datepicker__header {
      padding-top: 0px;
    }
    .react-datepicker__triangle {
      display: none;
    }
    .react-datepicker__navigation {
      border: solid #fff;
      border-width: 0 3px 3px 0;
      display: inline-block;
      margin: 0px 7px;
      padding: 4px;
      top: 14px;
      ${props => props.theme.mediaQueries.tablet_big_down}{
        padding: 8px;
        top: 11px;
      };
      :hover, :focus, :active {
         background-color: transparent; 
       }
    }
    .react-datepicker__day--selected {
      background-color: ${props => props.theme.colors.selectedColor};
      font-family: ${props => props.theme.fontSets.narrowRegular};
      border-radius: 0px;
        :hover {
          background-color: ${props => props.theme.colors.selectedColor};
          border-radius: 0px;
        }
    }
    .react-datepicker__day {
      font-family: ${props => props.theme.fontSets.narrowRegular};
      font-weight: normal;
      margin: 0.18rem;
        :hover {
          border-radius: 0px;
        }
    }
    .react-datepicker__day-names {
      background-color: #424F5E;
      font-family: ${props => props.theme.fontSets.narrowRegular};
      text-transform: uppercase;
      padding-top: 4px;      
    }
    .react-datepicker__day-name {
      color: #fff;
      font-weight: normal;
    }
    .react-datepicker__navigation--previous {
      box-shadow: none !important;
      border-right-color: #fff;
      transform: rotate(135deg);
       :hover {
        border-right-color: #fff;
       }
    }
    .react-datepicker__navigation--next  {
      box-shadow: none !important;
      border-left-color: #fff;
      transform: rotate(-45deg);
      :hover {
        border-left-color: #fff;
       }
    }
`;

export const SecondRowWrapper = styled.div`
  margin: ${props => (props.isMobile ? '16px 0px' : '10px 0px')};
     button {
      outline: none !important;
      background-color: none !important; 
    }
    .react-datepicker-popper {
      z-index: 999;
    }
    .react-datepicker__current-month {
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${props => props.theme.colors.selectedColor};
      color: #fff;
      font-family: ${props => props.theme.fontSets.narrowRegular};
    }
    .react-datepicker {
      box-shadow: -3px 3px 0 0 rgba(0,0,0,0.2);
      border: 0px;
      border-radius: 0px;
    }
    .react-datepicker__header {
      padding-top: 0px;
    }
    .react-datepicker__triangle {
      display: none;
    }
    .react-datepicker__navigation {
      border: solid #fff;
      border-width: 0 3px 3px 0;
      display: inline-block;
      margin: 0px 7px;
      padding: 4px;
      top: 14px;
        :hover, :focus, :active {
          background-color: transparent; 
        }
    }
    .react-datepicker__day--selected {
      background-color: ${props => props.theme.colors.selectedColor};
      font-family: ${props => props.theme.fontSets.narrowRegular};
      border-radius: 0px;
        :hover {
          background-color: ${props => props.theme.colors.selectedColor};
          border-radius: 0px;
        }
    }
    .react-datepicker__day {
      font-family: ${props => props.theme.fontSets.narrowRegular};
      font-weight: normal;
      margin: 0.18rem;
        :hover {
          border-radius: 0px;
        }
    }
    .react-datepicker__day-names {
      background-color: #424F5E;
      font-family: ${props => props.theme.fontSets.narrowRegular};
      text-transform: uppercase;
      padding-top: 4px;      
    }
    .react-datepicker__day-name {
      color: #fff;
      font-weight: normal;
    }
    .react-datepicker__navigation--previous {
      box-shadow: none !important;
      border-right-color: #fff;
      transform: rotate(135deg);
       :hover {
        border-right-color: #fff;
       }
    }
    .react-datepicker__navigation--next  {
      box-shadow: none !important;
      border-left-color: #fff;
      transform: rotate(-45deg);
      :hover {
        border-left-color: #fff;
       }
    }
`;

export const CarouselWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 2px 0;
  .orange {
    color: ${props => props.theme.colors.selectedColor}; !important;
   }
`;

export const WeekDay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${props => (props.isMobile ? '0px 7px' : '0px 8px')};
  cursor: pointer;
  pointer-events: ${props => (props.isPointerEvents ? 'none' : 'auto')};
`;

export const MobileDateButton = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 10px;
`;




// WEBPACK FOOTER //
// ./src/containers/BasketCalendarNba/NbaTopBar/styles.js